/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthModel, TwoFactorModel } from './_models'
import { Config } from '@/core/config/config';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';




const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return;
  }
  try {

    const authSession: string | null = localStorage.getItem(Config.VITE_APP_AUTH_SESSION as string)
    if (authSession) {
      return JSON.parse(authSession);
    }
    else {
      return;
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.setItem(Config.VITE_APP_AUTH_SESSION, JSON.stringify(auth))
    localStorage.setItem(Config.VITE_APP_AUTH_HASH as string, auth.hash);
    localStorage.setItem(Config.VITE_APP_ACCESS_TOKEN_KEY as string, auth.access_token)
    localStorage.setItem(Config.VITE_APP_REFRESH_TOKEN_KEY as string, auth.refresh_token)
    localStorage.setItem(Config.VITE_APP_ID_TOKEN_KEY as string, auth.id_token);
    localStorage.setItem(Config.VITE_APP_LANGUAGE_KEY as string, auth.language);
    localStorage.setItem(Config.VITE_APP_CULTURE_KEY as string, auth.culture);
    localStorage.setItem(Config.VITE_APP_I18N_CONFIG_KEY, JSON.stringify({ selectedLang: auth.language_short_code }))
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const setTwoFactorAuth = (twoFactorAuth: TwoFactorModel) => {
  if (!localStorage) {
    return
  }
  try {
    localStorage.setItem(Config.VITE_APP_AUTH_HASH as string, twoFactorAuth.hash);
  } catch (error) {
    console.error('TWO FACTOR AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const getAuthHash = (): any | undefined => {
  if (!localStorage) {
    return;
  }
  try {
    return localStorage.getItem(Config.VITE_APP_AUTH_HASH as string)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const getMenu = (): any | undefined => {
  if (!localStorage) {
    return;
  }
  try {

    const menu: string | null = localStorage.getItem('navigation')
    if (menu) {
      return JSON.parse(menu);
    }
    else {
      return;
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setMenu = (menu: any) => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.setItem('navigation', JSON.stringify(menu));
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const getPermissions = (): any | undefined => {
  if (!localStorage) {
    return;
  }
  try {

    const permissions: string | null = localStorage.getItem('perms')
    if (permissions) {
      return JSON.parse(permissions);
    }
    else {
      return;
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setPermissions = (permissions: any) => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.setItem('perms', JSON.stringify(permissions));
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const checkPermission = (permission: string, action?: string | undefined): boolean => {
  var result = false;
  try {
    const userPermissions = getPermissions();
    result = userPermissions.some((item: any) => (
      item.permCode === permission && (!action || item.actions.includes(action))
    ));
  } catch (error) {
    console.error('CHECK PERMISSION ERROR', error)
    removeAuth();
  }
  return result;
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(Config.VITE_APP_AUTH_SESSION)
    localStorage.removeItem(Config.VITE_APP_IMPERSONATOR_AUTH_SESSION)
    localStorage.removeItem(Config.VITE_APP_ACCESS_TOKEN_KEY as string)
    localStorage.removeItem(Config.VITE_APP_REFRESH_TOKEN_KEY as string)
    localStorage.removeItem(Config.VITE_APP_ID_TOKEN_KEY as string);
    localStorage.removeItem('navigation');
    localStorage.removeItem('perms');
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

const isTokenExpired = (token: any): boolean => {

  if (!token) return true;

  const { exp } = jwtDecode<{ exp: number }>(token);
  if (!exp) return true;

  const expirationTime = exp * 1000;
  return Date.now() > expirationTime;
};







export { getAuth, setAuth, getMenu, setMenu, getPermissions, setPermissions, checkPermission, removeAuth, isTokenExpired, setTwoFactorAuth, getAuthHash }